import { Component, OnInit, Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot  } from '@angular/router';

import { LocalStorageService } from 'ngx-webstorage';


@Injectable()
@Component({
  selector: 'app-admin-layout',
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent implements OnInit {


  public loginRegistrado: boolean = false;

  constructor(private storage: LocalStorageService,
    private router: Router) { }

  ngOnInit() {

    //valida si hay una sesion en el sistema si lo manda a home
    this.loginRegistrado = (this.storage.retrieve('sesion') != null);

    if (!this.loginRegistrado) {      
      this.router.navigate(['login'], { queryParams: { returnUrl: 'home' }});
      return false;
    }

  

   


  }

}
